import { RouterModule, Routes } from '@angular/router';

const routes: Routes = [
];

export const SubjectRoutingProvider = RouterModule.forRoot(routes, { useHash: true });